function initLoadMore() {
  const products_on_page = document.getElementById('product-grid');
  const container = document.getElementById('ProductGridContainer');
  const load_more_btn = document.querySelector('.load-more_btn');
  const load_more_spinner = document.querySelector('.load-more_spinner');
  const progress_bar = document.getElementById('progress-bar');
  const current_products_span = document.getElementById('current-products');
  const total_products_span = document.getElementById('total-products');

  if (!products_on_page || !container) return;

  let next_url = products_on_page.dataset.nextUrl || null;
  const autoLoad = container.dataset.autoScroll === 'true';
  let isLoading = false;

  async function getNextPage() {
    try {
      const res = await fetch(next_url);
      if (!res.ok) throw new Error('Network response was not OK');
      return await res.text();
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  }

  async function loadMoreProducts() {
    if (!next_url || isLoading) return;

    isLoading = true;
    if (!autoLoad) {
      load_more_btn.style.display = 'none';
      load_more_spinner.style.display = 'block';
    }

    const nextPageHTML = await getNextPage();
    isLoading = false;

    if (!autoLoad) load_more_spinner.style.display = 'none';
    if (!nextPageHTML) {
      if (!autoLoad) load_more_btn.style.display = 'flex';
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(nextPageHTML, 'text/html');
    const new_product_grid = doc.getElementById('product-grid');
    if (!new_product_grid) return;

    // Get new products and banners from loaded HTML
    const new_items = Array.from(new_product_grid.querySelectorAll('.grid__item, .collection-offer-banner'));

    // Track existing product handles already in live DOM
    const existingHandles = new Set(
      Array.from(products_on_page.querySelectorAll('.grid__item')).map(item =>
        item.getAttribute('data-product-handle'))
    );

    // Track banners already appended in live DOM by ID
    const alreadyAppendedBanners = new Set(
      Array.from(products_on_page.querySelectorAll('.collection-offer-banner'))
        .map(banner => banner.id)
    );

    new_items.forEach(item => {
      const isProduct = item.classList.contains('grid__item');
      const isBanner = item.classList.contains('collection-offer-banner');
      const id = item.id;

      if (isBanner) {
        // Skip if banner already appended
        if (id && alreadyAppendedBanners.has(id)) return;

        // Optional: Insert banner after specific product index (adjust as needed)
        // Example: first-banner after 6th product (index 5), second-banner after 10th (index 9)
        const insertAfterIndex = id === 'first-banner' ? 5 : (id === 'second-banner' ? 9 : null);
        if (insertAfterIndex !== null) {
          const referenceNode = products_on_page.querySelectorAll('.grid__item')[insertAfterIndex];
          if (referenceNode) {
            products_on_page.insertBefore(item, referenceNode.nextSibling);
          } else {
            products_on_page.appendChild(item);
          }
        } else {
          // Default append at end
          products_on_page.appendChild(item);
        }

        if (id) alreadyAppendedBanners.add(id);
        return;
      }

      if (isProduct) {
        const handle = item.getAttribute('data-product-handle');
        if (handle && !existingHandles.has(handle)) {
          products_on_page.appendChild(item);
        }
      }
    });

    next_url = new_product_grid.dataset.nextUrl;

    if (next_url) {
      if (!autoLoad) load_more_btn.style.display = 'flex';
    } else {
      load_more_btn.style.display = 'none';
      if (autoLoad) load_more_spinner.style.display = 'none';
    }

    const currentProductsCount = products_on_page.querySelectorAll('.grid__item').length;
    const totalProductsCount = parseInt(total_products_span.innerText);
    const percent = (currentProductsCount / totalProductsCount) * 100;

    progress_bar.style.width = `${percent}%`;
    current_products_span.innerText = currentProductsCount;
  }

  load_more_btn?.removeEventListener('click', loadMoreProducts);
  load_more_btn?.addEventListener('click', loadMoreProducts);

  if (autoLoad) {
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'flex';

    let debounceTimer = null;
    window.addEventListener('scroll', () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (!next_url || isLoading) return;
        const scrollPosition = window.innerHeight + window.scrollY;
        const productGridBottom = products_on_page.offsetTop + products_on_page.offsetHeight;
        const threshold = 100;
        if (scrollPosition >= productGridBottom - threshold) {
          loadMoreProducts();
        }
      }, 150);
    });
  } else {
    load_more_btn.style.display = 'flex';
    load_more_spinner.style.display = 'none';
  }
}

// Run on initial load
document.addEventListener('DOMContentLoaded', () => {
  initLoadMore();

  // Observe changes to #ProductGridContainer for sort/filter updates
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          initLoadMore();
          break;
        }
      }
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true,
    });
  }
});
